<script>
import Debug from '../components/debug';

export default {
  components: { Debug },
  props: {
    error: {
      type: null,
      default: () => ({
        message: '',
        statusCode: 500,
      }),
    },
  },
  /**
   * Handle errors client-side on page mount
   * 1. If error is caused by missing chunk and:
   *   1.1 this is first time it happens -> reload the page
   *   1.2 reload happened before -> crash and send report to Sentry
   * 2. Else crash and send report to Sentry
   */
  computed: {
    payload() {
      const { statusCode, message } = this.error;
      let payload;
      if (typeof message === 'object') {
        const { text, ...rest } = message;
        payload = { message: text, ...rest };
      } else {
        payload = { message };
      }

      return { ...payload, statusCode };
    },
  },
  mounted() {
    const { message, statusCode, fingerprint = [] } = this.payload;
    const isChunkError = /^Loading chunk [0-9]+ failed/.test(message);

    if (statusCode === 500 && isChunkError && window.location.hash !== '#retry') {
      // Case #1.1
      window.location.hash = '#retry';
      window.location.reload(true);
    } else {
      // Scroll page to top manually, since this is not redirect
      this.$scrollTo(document.body, 0);

      // Skip error logging if sentry is not enabled
      if (this.$sentry) {
        this.$sentry.withScope(scope => {
          scope.setUser({ id: this.$auth.user.id });
          scope.setTag('severity', 'critical');
          scope.setFingerprint(fingerprint);
          this.$sentry.captureException(new Error(message));
        });
      }
    }
  },
};
</script>
